const key = (userId:string) => `tableread.lastOpenScreenplay.${userId}`;
export function lastScreenplay(userId:string):string|null {
  try { return window.localStorage.getItem(key(userId)); } catch { return null; }
}
export function rememberScreenplay(userId:string,id:string|null) {
  try {
    if(id)window.localStorage.setItem(key(userId),id);
    else window.localStorage.removeItem(key(userId));
  } catch { /* A blocked preference must not prevent opening/saving a script. */ }
}
